module.exports = __webpack_public_path__ + "fonts/Vonnes-LightCondItalic.40f07d65.otf";